class PerformanceTracker {

  constructor() {
    this.moduleStartTimes = new Map();
    this.moduleTimers = new Map();
    this.endpoint = '/__/metrics/app-performance';
    this.bootstrapReported = false;
    this.networkRtt = -1;
    this.slowLoadThreshold = 10000;
    this.moduleLoadTimeout = 15000;
    this.rttProbePromise = this.probeNetworkRtt();
  }

  async probeNetworkRtt() {
    const timeoutPromise = new Promise(function createTimeoutPromise(resolve) {
      setTimeout(function onTimeout() {
        resolve(-1);
      }, 3000);
    });

    const start = performance.now();

    const fetchPromise = new Promise(function createFetchPromise(resolve) {
      fetch('/__/ping', { cache: 'no-store' })
        .then(function onPingSuccess() {
          resolve(Math.round(performance.now() - start));
        })
        .catch(function onPingError() {
          resolve(-1);
        });
    });

    this.networkRtt = await Promise.race([fetchPromise, timeoutPromise]);
  }

  async reportBootstrap() {
    try {
      if (this.bootstrapReported) {
        return;
      }

      const duration = performance.now();
      const bootstrapDataLoadDuration = performance.measure('bootstrap-data-load', 'app-load').duration;
      performance.clearMarks();
      this.bootstrapReported = true;

      await this.rttProbePromise;

      this.sendMetric('bootstrap-data-load', bootstrapDataLoadDuration);
      this.sendMetric('app-bootstrap', duration);
    } catch (error) {
      // intentionally silent — metrics must not affect app behaviour
    }
  }

  async reportLoad() {
    try {
      const duration = performance.now();
      performance.mark('app-load');

      await this.rttProbePromise;

      this.sendMetric('app-load', duration);
    } catch (error) {
      // intentionally silent — metrics must not affect app behaviour
    }
  }

  trackModuleBootstrap(name) {
    this.moduleStartTimes.set(name, performance.now());

    const timer = setTimeout(function onModuleLoadTimeout() {
      this.handleModuleLoadTimeout(name);
    }.bind(this), this.moduleLoadTimeout);

    this.moduleTimers.set(name, timer);
  }

  async handleModuleLoadTimeout(name) {
    try {
      this.moduleStartTimes.delete(name);
      this.moduleTimers.delete(name);

      await this.rttProbePromise;

      this.sendMetric(name, this.moduleLoadTimeout, true, true);
    } catch (error) {
      // intentionally silent — metrics must not affect app behaviour
    }
  }

  async reportModuleBootstrap(name) {
    try {
      const startTime = this.moduleStartTimes.get(name);

      if (startTime === undefined) {
        return;
      }

      clearTimeout(this.moduleTimers.get(name));
      this.moduleTimers.delete(name);

      const duration = performance.now() - startTime;
      this.moduleStartTimes.delete(name);

      await this.rttProbePromise;

      const isSlowLoad = duration > this.slowLoadThreshold;

      this.sendMetric(name, duration, isSlowLoad, false);
    } catch (error) {
      // intentionally silent — metrics must not affect app behaviour
    }
  }

  sendMetric(name, duration, isSlowLoad, timedOut) {

    const data = {
      name,
      duration,
      timestamp: Date.now(),
      networkRtt: this.networkRtt,
      isSlowLoad: isSlowLoad === true,
      timedOut: timedOut === true,
      a: 1
    };

    navigator.sendBeacon(this.endpoint, JSON.stringify(data));
  }
}

export default new PerformanceTracker();